import React from "react";
import Button from "react-bootstrap/Button";
import ButtonGroup from "react-bootstrap/ButtonGroup";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import { FaLayerGroup } from "react-icons/fa";

const EVENT_TIMEFRAMES = ["5M", "15M", "4H", "1D", "1W"];
const LOOKBACKS = ["24h", "7d", "30d", "All"];

export default function OverlaySettingsModal({
  show,
  onHide,
  settings,
  onChange,
  onApply,
  onClear,
  historyLoading,
  historyError,
  eventCount,
  markerCount,
}) {
  const update = (patch) => onChange({ ...settings, ...patch });

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      size="sm"
      className="overlaySettingsModal"
      contentClassName="overlaySettingsModalContent"
    >
      <Modal.Header closeButton closeVariant="white">
        <Modal.Title className="overlaySettingsTitle">
          <FaLayerGroup aria-hidden="true" />
          Overlays
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Check
          type="switch"
          id="custom-drawings-overlay"
          label="Custom drawings"
          checked={Boolean(settings.customDrawings)}
          onChange={(event) => update({ customDrawings: event.target.checked })}
          className="overlaySettingsSwitch"
        />
        <div className="overlaySettingsHint">
          Events, trades, orders, setup markers, AI levels, and chart annotations.
        </div>

        <fieldset disabled={!settings.customDrawings} className="overlaySettingsFieldset">
        <Form.Check
          type="switch"
          id="previous-day-levels-overlay"
          label="PDH / PDL"
          checked={Boolean(settings.previousDayLevels)}
          onChange={(event) => update({ previousDayLevels: event.target.checked })}
          className="overlaySettingsSwitch"
        />
        <div className="overlaySettingsHint">
          Previous UTC day high, low, and day-close marker. Intraday charts only.
        </div>
        <div className="overlaySettingsDivider" />
        <Form.Check
          type="switch"
          id="historical-events-overlay"
          label="Historical events"
          checked={Boolean(settings.historicalEvents)}
          onChange={(event) => update({ historicalEvents: event.target.checked })}
          className="overlaySettingsSwitch"
        />

        <fieldset disabled={!settings.historicalEvents} className="overlaySettingsFieldset">
          <legend>Event timeframe</legend>
          <ButtonGroup className="overlaySettingsSegments" aria-label="Historical event timeframe">
            {EVENT_TIMEFRAMES.map((timeframe) => (
              <Button
                key={timeframe}
                type="button"
                variant={settings.eventTimeframe === timeframe ? "primary" : "outline-secondary"}
                onClick={() => update({ eventTimeframe: timeframe })}
              >
                {timeframe}
              </Button>
            ))}
          </ButtonGroup>

          <legend>Lookback</legend>
          <ButtonGroup className="overlaySettingsSegments" aria-label="Historical event lookback">
            {LOOKBACKS.map((lookback) => (
              <Button
                key={lookback}
                type="button"
                variant={settings.lookback === lookback ? "primary" : "outline-secondary"}
                onClick={() => update({ lookback })}
              >
                {lookback}
              </Button>
            ))}
          </ButtonGroup>

          <div className="overlaySettingsCount" aria-live="polite">
            {historyLoading && "Loading history..."}
            {!historyLoading && historyError && "History is currently unavailable."}
            {!historyLoading && !historyError && `${eventCount} events grouped into ${markerCount} markers`}
          </div>
        </fieldset>

        <div className="overlaySettingsDivider" />

        <Form.Check
          type="switch"
          id="btc-regime-overlay"
          label="BTC regime zones"
          checked={Boolean(settings.btcRegime)}
          onChange={(event) => update({ btcRegime: event.target.checked })}
          className="overlaySettingsSwitch"
        />
        </fieldset>
      </Modal.Body>
      <Modal.Footer>
        <Button type="button" variant="outline-danger" onClick={onClear}>
          Clear all
        </Button>
        <div className="overlaySettingsFooterActions">
          <Button type="button" variant="secondary" onClick={onHide}>
            Cancel
          </Button>
          <Button type="button" variant="primary" onClick={onApply}>
            Apply
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}
